{
  "codexEntityForm": {
    "character": "Personaggio",
    "place": "Luogo",
    "faction": "Fazione",
    "object": "Oggetto",
    "concept": "Concetto",
    "editName": "Modifica {{name}}",
    "newCodexEntry": "Nuova voce dell'Enciclopedia",
    "theWorldHasChangedTheDraft": "Il mondo è cambiato. La bozza è conservata; ricarica la voce prima di salvare.",
    "portraitChooseAnImage": "Ritratto: scegli un'immagine",
    "change": "Cambia",
    "addPortrait": "Aggiungi ritratto",
    "portraitImage": "Immagine del ritratto",
    "entryName": "Nome della voce",
    "name": "Nome",
    "entryType": "Tipo di voce",
    "customCategory": "Categoria personalizzata",
    "categoryEGDeityShipSpell": "Categoria, per esempio Divinità, Nave, Incantesimo",
    "aliases": "Alias",
    "entryAliases": "Alias della voce",
    "otherNamesOneAtATime": "Altri nomi, uno alla volta…",
    "tags": "Tag",
    "entryTags": "Tag della voce",
    "themesRolesArcs": "Temi, ruoli, archi…",
    "collection": "Raccolta",
    "entryCollection": "Raccolta della voce",
    "noCustomCollection": "Nessuna raccolta personalizzata",
    "folder": "Cartella",
    "entryFolder": "Cartella della voce",
    "unfiled": "Non archiviata",
    "notes": "Note",
    "entryNotes": "Note della voce",
    "whoTheyAreWhatTheyWant": "Chi è, cosa vuole, cosa chi legge non deve scoprire troppo presto…",
    "entryFields": "Campi della voce",
    "fields": "Campi",
    "fieldTemplate": "Modello di campi",
    "template": "Modello…",
    "schemaOf": "Schema di",
    "addMissingFields": "Aggiungi i campi mancanti",
    "addField": "Aggiungi campo",
    "noCustomFieldYetFieldsGive": "Ancora nessun campo personalizzato. I campi danno a una voce fatti strutturati — età, fedeltà, un segreto — su cui i Controlli possono ragionare.",
    "sharedFieldNamesTypesAndOptions": "I nomi, i tipi e le opzioni dei campi condivisi si gestiscono nelle impostazioni della raccolta. I valori appartengono a questa pagina.",
    "fieldNameN": "Nome del campo {{n}}",
    "fieldName": "Nome del campo",
    "fieldTypeN": "Tipo di campo {{n}}",
    "unknown": "Sconosciuto",
    "fieldValueN": "Valore del campo {{n}}",
    "select": "Seleziona…",
    "yes": "Sì",
    "no": "No",
    "value": "Valore",
    "chooseAnEntry": "Scegli una voce…",
    "eGSpringOfYear12": "per esempio primavera dell'anno 12, o il giorno dell'assedio",
    "below": "Sotto",
    "unknownValueN": "Valore sconosciuto {{n}}",
    "required": "Obbligatorio",
    "sharedField": "Campo condiviso",
    "remove": "Rimuovi",
    "confirmRemoval": "Conferma la rimozione",
    "paragraph": "Paragrafo",
    "aFewLines": "Qualche riga…",
    "discardTheDraft": "Scartare la bozza?",
    "confirmReload": "Conferma il ricaricamento",
    "keepEditing": "Continua a modificare",
    "reloadEntry": "Ricarica la voce",
    "cancel": "Annulla",
    "chooseAnImageFileForThe": "Scegli un file immagine per il ritratto.",
    "thePortraitMustBeUnder8": "Il ritratto deve pesare meno di 8 MiB.",
    "saveEntry": "Salva voce",
    "searchEntries": "Cerca voci…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "Nuova voce dell'Enciclopedia",
    "savedToWorldCodexTheManuscript": "Salvata in Mondo › Enciclopedia; il manoscritto la citerà dove stavi scrivendo.",
    "createAndMention": "Crea e menziona"
  },
  "continuityPanel": {
    "relationsOverTime": "Relazioni nel tempo",
    "checkingRelations": "Controllo delle relazioni…",
    "cancel": "Annulla",
    "theProjectHasChangedRunThe": "Il manoscritto o il mondo sono cambiati dopo questa esecuzione. Esegui di nuovo i controlli per aggiornare le relazioni.",
    "anAnalysisLimitWasReachedThe": "È stato raggiunto un limite di analisi. Il risultato è parziale.",
    "ruleApplied": "Regola: «{{label}}», {{rule}}.",
    "oneSourcePerTarget": "una sola origine per ogni destinazione",
    "oneTargetPerSource": "una sola destinazione per ogni origine",
    "interval": "da {{start}} a {{end}}",
    "openScene": "Apri {{scene}}",
    "findingReferenceMissing": "Rimanda a una voce che non esiste più.",
    "findingConfirmedWithoutEvidence": "Confermata senza una citazione dal testo, quindi la sua fonte non si può verificare.",
    "findingEvidenceMissing": "Una citazione su cui si basa non c'è più.",
    "findingEvidenceNotCurrent": "Una citazione su cui si basa non è confermata o non corrisponde più al testo.",
    "findingExclusiveNotEvaluable": "Non si può verificare con la regola: servono una direzione, entrambe le estremità e un intervallo di tempo completo.",
    "findingExclusiveOverlap": "Due di queste valgono nello stesso momento, cosa che la regola non consente.",
    "findingOther": "Qualcosa da controllare in questa relazione.",
    "theProjectExceedsTheLimitOf": "Il progetto supera il limite di questa analisi. Nessun dato è stato modificato.",
    "theAnalysisExceededItsExecutionLimit": "L'analisi ha superato il suo limite di esecuzione. Nessun dato è stato modificato.",
    "analysisCancelled": "Analisi annullata.",
    "checksNotCompletedTheTextAnd": "Controlli non completati. Il testo e il canone non sono stati modificati."
  },
  "eventTimelinePanel": {
    "eventHistory": "Storia degli eventi",
    "timeline": "Cronologia",
    "newEvent": "Nuovo evento",
    "searchEvents": "Cerca eventi",
    "searchEvents2": "Cerca eventi…",
    "timelineOrder": "Ordine della cronologia",
    "storyTime": "Tempo della storia",
    "readingOrder": "Ordine di lettura",
    "dateStatus": "Stato della data",
    "allDates": "Tutte le date",
    "resolvedDates": "Date risolte",
    "unresolvedDates": "Date non risolte",
    "filterEventsByScene": "Filtra gli eventi per scena",
    "allScenes": "Tutte le scene",
    "scenes": "Scene",
    "editEvent": "Modifica evento",
    "closeEventEditor": "Chiudi l'editor degli eventi",
    "theWorldHasChangedReloadThe": "Il mondo è cambiato. Ricarica l'evento prima di salvare; i campi della bozza sono conservati.",
    "eventTitle": "Titolo dell'evento",
    "whatHappens": "Cosa succede",
    "scene": "Scena",
    "eventScene": "Scena dell'evento",
    "notLinked": "Non collegato",
    "removedSceneSceneid": "Scena rimossa — {{sceneId}}",
    "dateType": "Tipo di data",
    "eventDateType": "Tipo di data dell'evento",
    "unknown": "Sconosciuta",
    "definedInterval": "Intervallo definito",
    "relativeToAnEvent": "Relativa a un evento",
    "start": "Inizio",
    "eventStart": "Inizio dell'evento",
    "endExclusive": "Fine (esclusa)",
    "eventEnd": "Fine dell'evento",
    "referenceEvent": "Evento di riferimento",
    "select": "Seleziona…",
    "referenceToVerifyAnchoreventid": "Riferimento da verificare — {{anchorEventId}}",
    "events": "Eventi",
    "offsetInTicks": "Scostamento in istanti",
    "eventOffset": "Scostamento dell'evento",
    "saveEvent": "Salva evento",
    "closeReload": "Chiudi / ricarica…",
    "discardTheDraftChanges": "Scartare le modifiche della bozza?",
    "discardDraft": "Scarta la bozza",
    "reloadEvent": "Ricarica l'evento",
    "keepEditing": "Continua a modificare",
    "noEventMatchesTheseFiltersEvents": "Nessun evento corrisponde a questi filtri. Gli eventi sono ciò su cui ragionano i Controlli: quando è successo qualcosa e in quale scena chi legge lo scopre.",
    "tickStart": "Istante {{start}}",
    "openScene": "Apri la scena",
    "editTitle": "Modifica {{title}}",
    "removeTitle": "Rimuovi {{title}}",
    "confirmEventRemoval": "Conferma la rimozione dell'evento",
    "cancel": "Annulla",
    "theWorldHasChangedCancelAnd": "Il mondo è cambiato: annulla e riapri la conferma.",
    "resolvedDate": "Data risolta",
    "unknownDate": "Data sconosciuta",
    "missingReference": "Riferimento mancante",
    "timeCycle": "Ciclo temporale",
    "dateOutOfRange": "Data fuori intervallo",
    "eventsFoundOfTotal_one": "{{count}} evento trovato · {{total}} in totale",
    "eventsFoundOfTotal_many": "{{count}} eventi trovati · {{total}} in totale",
    "eventsFoundOfTotal_other": "{{count}} eventi trovati · {{total}} in totale",
    "removeThisEventReferences_one": "Rimuovere questo evento? {{count}} riferimento diretto dovrà essere rivisto.",
    "removeThisEventReferences_many": "Rimuovere questo evento? {{count}} riferimenti diretti dovranno essere rivisti.",
    "removeThisEventReferences_other": "Rimuovere questo evento? {{count}} riferimenti diretti dovranno essere rivisti.",
    "showMoreEvents_one": "Mostra {{count}} altro evento",
    "showMoreEvents_many": "Mostra altri {{count}} eventi",
    "showMoreEvents_other": "Mostra altri {{count}} eventi"
  },
  "fieldEditor": {
    "choose": "Scegli…",
    "labelSearch": "Ricerca: {{label}}",
    "search": "Cerca…",
    "labelOptions": "Opzioni: {{label}}",
    "noMatch": "Nessun risultato.",
    "optionsOnePerLine": "Opzioni, una per riga",
    "fieldOptionsIndex": "Opzioni del campo {{index}}",
    "addOptionIndex": "Aggiungi opzione {{index}}",
    "newOption": "Nuova opzione",
    "addOption": "Aggiungi opzione",
    "fieldValueIndex": "Valore del campo {{index}}",
    "chooseOptions": "Scegli le opzioni…",
    "chooseEntries": "Scegli le voci…",
    "unsupportedMultiValueEditor": "Editor a più valori non supportato"
  },
  "graphExplorer": {
    "relationGraph": "Grafo delle relazioni",
    "entry": "Voce",
    "filterGraphByEntry": "Filtra il grafo per voce",
    "all": "Tutte",
    "status": "Stato",
    "graphRelationStatus": "Stato delle relazioni nel grafo",
    "proposedAndConfirmed": "Proposte e confermate",
    "confirmed": "Confermate",
    "proposed": "Proposte",
    "relation": "Relazione",
    "searchRelationInTheGraph": "Cerca una relazione nel grafo",
    "filterAtStoryTime": "Filtra per tempo della storia",
    "tick": "Istante",
    "graphTick": "Istante del grafo",
    "includeUnknownTime": "Includi il tempo sconosciuto",
    "enterANumericTickOrTurn": "Inserisci un istante numerico oppure disattiva il filtro temporale.",
    "navigableRelationGraph": "Grafo delle relazioni navigabile",
    "selectName": "Seleziona {{name}}",
    "entryCount_one": "{{count}} voce",
    "entryCount_many": "{{count}} di voci",
    "entryCount_other": "{{count}} voci",
    "relationCount_one": "{{count}} relazione",
    "relationCount_many": "{{count}} di relazioni",
    "relationCount_other": "{{count}} relazioni",
    "hiddenBeyondViewLimit": "{{entries}} e {{relations}} oltre il limite di visualizzazione.",
    "relationsWithMissingEntries_one": "{{count}} relazione con voci mancanti.",
    "relationsWithMissingEntries_many": "{{count}} relazioni con voci mancanti.",
    "relationsWithMissingEntries_other": "{{count}} relazioni con voci mancanti.",
    "unknownDurationIncluded_one": "{{count}} relazione con durata sconosciuta inclusa nel filtro.",
    "unknownDurationIncluded_many": "{{count}} relazioni con durata sconosciuta incluse nel filtro.",
    "unknownDurationIncluded_other": "{{count}} relazioni con durata sconosciuta incluse nel filtro.",
    "unknownDurationExcluded_one": "{{count}} relazione con durata sconosciuta esclusa dal filtro.",
    "unknownDurationExcluded_many": "{{count}} relazioni con durata sconosciuta escluse dal filtro.",
    "unknownDurationExcluded_other": "{{count}} relazioni con durata sconosciuta escluse dal filtro."
  },
  "relationshipPanel": {
    "select": "Seleziona…",
    "removedReference": "Riferimento rimosso:",
    "projectRelations": "Relazioni del progetto",
    "relationsOf": "Relazioni di",
    "filterRelationsByEntry": "Filtra le relazioni per voce",
    "allEntries": "Tutte le voci",
    "searchEntries": "Cerca voci…",
    "searchRelations": "Cerca relazioni",
    "relationOrEntry": "Relazione o voce",
    "newRelation": "Nuova relazione",
    "editRelation": "Modifica relazione",
    "relationsLinkTwoEntries": "Le relazioni collegano due voci",
    "addTwoEntriesInTheCodex": "Aggiungi almeno due voci nell'Enciclopedia, poi scrivi le parole che le legano, come «è il mentore di».",
    "theWorldHasChangedTheFields": "Il mondo è cambiato mentre questa schermata era aperta. I tuoi campi sono conservati; ricarica per salvare sui nuovi dati.",
    "reload": "Ricarica",
    "anEntry": "Una voce",
    "anotherEntry": "Un'altra voce",
    "relationSource": "Origine della relazione",
    "relationType": "Tipo di relazione",
    "isTheMentorOf": "è il mentore di",
    "relationTarget": "Destinazione della relazione",
    "direction": "Direzione",
    "relationDirection": "Direzione della relazione",
    "oneWay": "A senso unico",
    "bothWays": "In entrambi i sensi",
    "when": "Quando",
    "relationTime": "Tempo della relazione",
    "notSet": "Non impostato",
    "betweenTwoMoments": "Tra due momenti",
    "fromAnEvent": "Da un evento",
    "from": "Da",
    "to": "a",
    "relationStart": "Inizio della relazione",
    "relationEnd": "Fine della relazione",
    "momentsHint": "Momenti sulla cronologia del mondo; la fine non è inclusa.",
    "event": "Evento",
    "relationEvent": "Evento della relazione",
    "offset": "Scostamento",
    "relationOffset": "Scostamento della relazione",
    "offsetHint": "Momenti dopo l'evento; negativo per prima.",
    "status": "Stato",
    "relationStatus": "Stato della relazione",
    "proposed": "Proposta",
    "confirmed": "Confermata",
    "rejected": "Rifiutata",
    "superseded": "Sostituita",
    "confirmedRelationsCountAsCanonIn": "Le relazioni confermate contano come canone nei Controlli.",
    "notes": "Note",
    "relationNotes": "Note della relazione",
    "howTheStoryShowsItAnd": "Come la storia la mostra e cosa resta ambiguo.",
    "quotes": "Citazioni",
    "linkQuotes": "Collega citazioni dal testo",
    "quotesLinked": "Citazioni: {{count}}",
    "searchQuotations": "Cerca citazioni",
    "excerptOrNote": "Estratto o nota",
    "removedQuotation": "Citazione rimossa:",
    "noQuotationYetAnnotateAPassage": "Ancora nessuna citazione. Annota un passaggio nel manoscritto per citarlo qui.",
    "upTo100QuotationsShownUse": "Sono mostrate fino a 100 citazioni. Usa la ricerca per restringere l'elenco.",
    "saveRelation": "Salva relazione",
    "cancel": "Annulla",
    "aDeletedEntry": "una voce eliminata",
    "aDeletedEvent": "un evento eliminato",
    "timeBetween": "Da {{start}} a {{end}}",
    "timeAtEvent": "A {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "Ancora nessuna relazione.",
    "noRelationMatches": "Nessuna relazione corrisponde.",
    "edit": "Modifica",
    "editCaption": "Modifica {{caption}}",
    "remove": "Rimuovi",
    "removeCaption": "Rimuovi {{caption}}",
    "removeThisRelationTheChangeStays": "Rimuovere questa relazione? La modifica resta nella cronologia.",
    "confirmRemoval": "Rimuovi",
    "shownOfTotal": "Mostrate 100 relazioni su {{total}}. Restringi la ricerca per vedere le altre.",
    "theWorldHasChangedReloadThe": "Il mondo è cambiato. Ricarica la relazione prima di salvare.",
    "theRelationWasChangedOrRemoved": "La relazione è stata modificata o rimossa. Ricarica i dati.",
    "explicitlyConfirmTheRelationBeforeSaving": "Scegli di nuovo Confermata per rendere canone questa relazione.",
    "selectTwoEntriesThatExistIn": "Seleziona due voci che esistono nell'Enciclopedia.",
    "fillInTheTimeValuesOr": "Compila i momenti, oppure scegli Non impostato.",
    "enterAValidIntervalTheEnd": "La fine deve venire dopo l'inizio.",
    "selectAnExistingEventAsThe": "Scegli un evento che esiste ancora.",
    "theSelectedQuotationIsNoLonger": "Una citazione scelta non esiste più.",
    "checkTheRelationTextAndThe": "Controlla le parole della relazione e le note.",
    "theChangeWasNotSavedReload": "La modifica non è stata salvata. Ricarica i dati e riprova."
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "Accedi all'account collegato e controlla il tuo accesso a questo progetto. Le tue modifiche locali sono conservate.",
    "syncTheManuscriptWithThisServer": "Sincronizza il manoscritto con questo server prima di collegare il suo Mondo.",
    "theWorldChangedAfterTheComparison": "Il Mondo è cambiato dopo il confronto. Rivedi di nuovo le copie attuali.",
    "aConfirmationOrRestoredRecordNeeds": "Una conferma o un record ripristinato richiedono una revisione esplicita prima di poter essere sincronizzati.",
    "anAttachmentOrRemoteCopyFailed": "Un allegato o una copia remota non ha superato la verifica. Il tuo Mondo locale è conservato.",
    "theseChangesExceedASyncLimit": "Queste modifiche superano un limite di sincronizzazione o devono essere applicate insieme. Il tuo Mondo locale e le modifiche in sospeso sono conservati.",
    "syncPausedYourLocalChangesAre": "Sincronizzazione in pausa. Le tue modifiche locali sono conservate.",
    "newMapNeedsPlan": "Le nuove mappe sono incluse in Ink e Press. La mappa resta su questo dispositivo e il Mondo aspetta: rimuovi la nuova mappa, o scegli un piano, per sincronizzarlo di nuovo.",
    "worldSyncCouldNotFinishCheck": "La sincronizzazione del Mondo non è terminata. Controlla la connessione e riprova. Le tue modifiche locali sono conservate."
  },
  "vaultFolders": {
    "folderName": "Cartella {{name}}",
    "editFolder": "Modifica cartella",
    "newSubfolder": "Nuova sottocartella",
    "moveContentsBeforeRemoving": "Sposta i contenuti prima di rimuovere",
    "removeFolder": "Rimuovi cartella",
    "folderActionsName": "Azioni della cartella {{name}}",
    "chooseThisFolderWhenEditingA": "Scegli questa cartella quando modifichi una pagina.",
    "projectFolders": "Cartelle del progetto",
    "folders": "Cartelle",
    "newFolder": "Nuova cartella",
    "groupPagesFromAnyCollection": "Raggruppa pagine di qualsiasi raccolta.",
    "foldersOrganizePagesWithoutChangingTheir": "Le cartelle organizzano le pagine senza cambiarne la raccolta o il contenuto.",
    "cancel": "Annulla",
    "saveFolder": "Salva cartella",
    "name": "Nome",
    "folderName2": "Nome della cartella",
    "inside": "Dentro",
    "parentFolder": "Cartella superiore",
    "projectRoot": "Radice del progetto",
    "removeEmptyFolder": "Rimuovere la cartella vuota?",
    "removeNameFromTheProject": "Rimuovere «{{name}}» dal progetto?"
  },
  "vaultTable": {
    "unavailableEntry": "Voce non disponibile",
    "vaultTable": "Tabella dell'Archivio",
    "pages": "Pagine",
    "searchVaultTable": "Cerca nella tabella dell'Archivio",
    "searchPages": "Cerca pagine…",
    "tableCollection": "Raccolta della tabella",
    "allCollections": "Tutte le raccolte",
    "noCustomCollection": "Nessuna raccolta personalizzata",
    "tableFolder": "Cartella della tabella",
    "allFolders": "Tutte le cartelle",
    "unfiled": "Non archiviata",
    "scrollableVaultTable": "Tabella dell'Archivio scorrevole",
    "name": "Nome",
    "collection": "Raccolta",
    "folder": "Cartella",
    "noPagesMatchTheseFilters": "Nessuna pagina corrisponde a questi filtri.",
    "none": "Nessuno",
    "yes": "Sì",
    "no": "No",
    "pagesShown_one": "{{shown}} di {{count}} pagina",
    "pagesShown_many": "{{shown}} di {{count}} pagine",
    "pagesShown_other": "{{shown}} di {{count}} pagine"
  },
  "vaultTree": {
    "blue": "Blu",
    "emerald": "Smeraldo",
    "gold": "Oro",
    "violet": "Viola",
    "rose": "Rosa",
    "amber": "Ambra",
    "teal": "Verde acqua",
    "slate": "Ardesia",
    "crimson": "Cremisi",
    "bark": "Corteccia",
    "forest": "Foresta",
    "navy": "Blu marino",
    "orchid": "Orchidea",
    "saffron": "Zafferano",
    "ink": "Inchiostro",
    "ember": "Brace",
    "concept": "Concetto",
    "character": "Personaggio",
    "place": "Luogo",
    "faction": "Fazione",
    "object": "Oggetto",
    "vault": "Archivio",
    "newCollection": "Nuova raccolta",
    "vaultView": "Vista dell'Archivio",
    "pages": "Pagine",
    "table": "Tabella",
    "pagesMarkedUnassignedKeepTheirPrevious": "Le pagine segnate come non assegnate conservano i campi precedenti. Modifica una pagina per scegliere la sua raccolta.",
    "filterPages": "Filtra le pagine",
    "filterPages2": "Filtra le pagine…",
    "worldVault": "Archivio del mondo",
    "removeCollectionName": "Rimuovi la raccolta {{name}}",
    "collectionSettingsForName": "Impostazioni della raccolta {{name}}",
    "iconAndColour": "Icona e colore",
    "newPageInName": "Nuova pagina in {{name}}",
    "noPageYetAddTheFirst": "Ancora nessuna pagina: aggiungi la prima con +.",
    "nothingHereYet": "Ancora niente qui.",
    "removeEmptyCollection": "Rimuovere la raccolta vuota?",
    "removeNameAndItsSchema": "Rimuovere «{{name}}» e il suo schema?",
    "removeCollection": "Rimuovi raccolta",
    "text": "Testo",
    "theSvgMustBeUnder16": "L'SVG deve pesare meno di 16 KiB.",
    "thisFileIsNotAUsable": "Questo file non è un SVG utilizzabile (script e riferimenti esterni vengono rimossi; la radice deve essere <svg>).",
    "collectionName": "Raccolta: {{name}}",
    "sharedFieldsApplyToEveryPage": "I campi condivisi si applicano a ogni pagina di questa raccolta. Ogni pagina può avere anche campi propri.",
    "cancel": "Annulla",
    "saving": "Salvataggio…",
    "saveCollection": "Salva raccolta",
    "createCollection": "Crea raccolta",
    "identity": "Identità",
    "nameAndIconAsTheTree": "Nome e icona, come li mostreranno l'albero e le pagine.",
    "name": "Nome",
    "collectionName2": "Nome della raccolta",
    "magic": "Magia",
    "aCollectionWithThisNameAlready": "Esiste già una raccolta con questo nome.",
    "icon": "Icona",
    "iconSource": "Origine dell'icona",
    "lucide181": "Lucide (181)",
    "yourSvg": "Il tuo SVG",
    "collectionIcon": "Icona della raccolta",
    "searchLucideIcons": "Cerca icone Lucide",
    "searchIconsCastleSwordMoon": "Cerca icone — castello, spada, luna…",
    "loadingIcons": "Caricamento delle icone…",
    "lucideIcon": "Icona Lucide",
    "noIconMatches": "Nessuna icona corrisponde.",
    "chooseAnSvgFile": "Scegli un file SVG",
    "customSvgIcon": "Icona SVG personalizzata",
    "upTo16KibScriptsLinks": "Fino a 16 KiB. Script, link e riferimenti esterni vengono rimossi; usa currentColor nel file perché si applichi il colore della raccolta.",
    "colour": "Colore",
    "aPresetOneYouUsedRecently": "Un colore predefinito, uno usato di recente o uno tuo dalla ruota.",
    "collectionColour": "Colore della raccolta",
    "recent": "Recenti",
    "useHex": "Usa {{hex}}",
    "kindOfPage": "Tipo di pagina",
    "everyPageIsACodexEntry": "Ogni pagina è una voce dell'Enciclopedia di un certo tipo; il tipo decide come la trattano i Controlli, le menzioni @ e il grafo, e ne mantiene il colore ovunque.",
    "collectionBaseKind": "Tipo di base della raccolta",
    "magicOrShipsConceptDeitiesOr": "Magia o Navi → Concetto · Divinità o Casate → Personaggio o Fazione · una raccolta di cittadine → Luogo.",
    "sharedFields": "Campi condivisi",
    "thePropertiesOfTheCollectionValues": "Le proprietà della raccolta — i valori stanno su ogni pagina, e una pagina può comunque aggiungerne di propri.",
    "collectionTemplate": "Modello della raccolta",
    "template": "Modello…",
    "addField": "Aggiungi campo",
    "exampleMagicLevelNumberRarityChoice": "Esempio: Magia → Livello (numero) · Rarità (scelta: comune, rara, leggendaria) · Ottenuta (data della storia) · Insegnata da (collegamento a una voce).",
    "collectionFieldNameValue": "Nome del campo della raccolta {{value}}",
    "fieldName": "Nome del campo",
    "collectionFieldTypeValue": "Tipo del campo della raccolta {{value}}",
    "collectionFieldOptionsValue": "Opzioni del campo della raccolta {{value}}",
    "optionsOnePerLine": "Opzioni, una per riga",
    "required": "Obbligatorio",
    "requiredCollectionFieldValue": "Campo della raccolta obbligatorio {{value}}",
    "removeCollectionFieldValue": "Rimuovi il campo della raccolta {{value}}",
    "yesNo": "Sì / No",
    "multipleChoice": "Scelta multipla",
    "storyDate": "Data della storia",
    "entryLink": "Collegamento a una voce",
    "multipleEntryLinks": "Più collegamenti a voci",
    "fieldParagraph": "Paragrafo",
    "fieldNumber": "Numero",
    "fieldChoice": "Scelta"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "Versioni cloud del Mondo",
    "includesCodexPagesCollectionsFoldersFacts": "Include pagine dell'Enciclopedia, raccolte, cartelle, fatti, relazioni e allegati. Pubblica o scarica una versione in modo esplicito. Il manoscritto usa la sincronizzazione delle scene.",
    "compareVersions": "Confronta le versioni",
    "recoverPreviousWorld": "Recupera il Mondo precedente…",
    "deviceRevision": "Revisione del dispositivo",
    "accountVersionRemoteversion": "Versione dell'account {{remoteVersion}}",
    "firstAccountVersion": "Prima versione dell'account",
    "uploadDeviceVersion": "Carica la versione del dispositivo…",
    "useAccountVersion": "Usa la versione dell'account…",
    "confirmTransfer": "Conferma il trasferimento",
    "replaceWorldOnThisDeviceWith": "Sostituire il Mondo su questo dispositivo con questa versione? Prima verrà conservata una copia del Mondo e degli allegati attuali. Il testo del manoscritto resta invariato.",
    "saveThisCopyToYourAccount": "Salvare questa copia nel tuo account? Le versioni precedenti dell'account verranno conservate.",
    "restoreWorldFromBeforeTheLast": "Ripristinare il Mondo precedente all'ultimo trasferimento? Le modifiche successive impediscono questo ripristino.",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "transferring": "Trasferimento…",
    "codexPages": "Pagine dell'Enciclopedia",
    "updateStoryideBeforePublishingChangesTo": "Aggiorna Musael prima di pubblicare modifiche a questo Archivio.",
    "theAccountVersionChangedCompareAgain": "La versione dell'account è cambiata. Confronta di nuovo prima di applicare.",
    "worldChangedOnThisDeviceCompare": "Il Mondo è cambiato su questo dispositivo. Confronta di nuovo prima di applicare.",
    "accountVersionStorageIsFullPrevious": "L'archiviazione delle versioni dell'account è piena. Le copie precedenti sono conservate.",
    "anAttachmentFailedItsIntegrityCheck": "Un allegato non ha superato il controllo di integrità. Nessuna copia locale è stata sostituita.",
    "theAccountCopyFailedItsIntegrity": "La copia dell'account non ha superato il controllo di integrità.",
    "noRecoveryCopyIsAvailableFor": "Nessuna copia di recupero è disponibile per questo trasferimento.",
    "anIdentifierIsAlreadyUsedIn": "Un identificatore è già usato in un altro progetto.",
    "openOrSyncTheManuscriptWith": "Apri o sincronizza prima il manoscritto con il tuo account.",
    "yourAccountDoesNotHaveThe": "Il tuo account non ha l'autorizzazione necessaria.",
    "signInAgainThisSessionWas": "Accedi di nuovo. Questa sessione è stata revocata.",
    "transferCancelled": "Trasferimento annullato.",
    "transferFailedCheckYourConnectionAnd": "Trasferimento non riuscito. Controlla la connessione e confronta di nuovo.",
    "couldNotReadTheRecoveryCopy": "Non è stato possibile leggere la copia di recupero.",
    "mondoPrecedenteRipristinato": "Mondo precedente ripristinato.",
    "accountVersionVersionSaved": "Versione dell'account {{version}} salvata.",
    "versionVersionAppliedToWorldOn": "Versione {{version}} applicata al Mondo su questo dispositivo.",
    "cancellationRequested": "Annullamento richiesto.",
    "labelFacts": "Fatti",
    "labelEvents": "Eventi",
    "labelKnowledge": "Conoscenza",
    "labelAnnotations": "Annotazioni",
    "labelRelationships": "Relazioni",
    "labelAttachments": "Allegati",
    "labelCollections": "Raccolte",
    "labelFolders": "Cartelle",
    "changedCount_one": "{{count}} modificato",
    "changedCount_many": "{{count}} modificati",
    "changedCount_other": "{{count}} modificati"
  },
  "worldMaps": {
    "character": "Personaggio",
    "place": "Luogo",
    "object": "Oggetto",
    "faction": "Fazione",
    "concept": "Concetto",
    "pinOf": "Segnaposto: {{name}}",
    "pinMissing": "Segnaposto di una voce mancante",
    "missingEntry": "Voce mancante",
    "zoom": "Zoom",
    "zoomIn": "Ingrandisci",
    "zoomOut": "Riduci",
    "fitToView": "Adatta alla vista",
    "newMap": "Nuova mappa",
    "newMapDescription": "Un'immagine di un luogo, per segnaposto su persone, luoghi e cose che vi si trovano.",
    "cancel": "Annulla",
    "saving": "Salvataggio…",
    "createMap": "Crea mappa",
    "mapOf": "Mappa di",
    "aNewPlace": "Un nuovo luogo",
    "placeName": "Nome del luogo",
    "placeNamePlaceholder": "La Costa del Sale",
    "picture": "Immagine",
    "choosePicture": "Scegli un PNG, JPEG, WebP o GIF",
    "pictureHint": "Fino a 16 MB. Diventa uno degli allegati della voce.",
    "maps": "Mappe",
    "mapsLead": "Fissa le voci sulle immagini dei tuoi luoghi. Un luogo fissato che ha una mappa propria la apre.",
    "noMapsYet": "Ancora nessuna mappa",
    "noMapsText": "Dai a un luogo un'immagine, poi fissa le voci che gli appartengono.",
    "addTheFirstMap": "Aggiungi la prima mappa",
    "onePin": "1 segnaposto",
    "pins": "{{count}} segnaposto",
    "inPlace": "su {{place}}",
    "chooseAnEntryOrName": "Scegli una voce o scrivi un nome per il segnaposto.",
    "mapTrail": "Mappe sopra questa",
    "doneAdding": "Fatto",
    "addPin": "Aggiungi segnaposto",
    "labels": "Etichette",
    "replacePicture": "Sostituisci l'immagine",
    "removeMap": "Rimuovi la mappa",
    "hintClick": "Fai clic sulla mappa dove va il segnaposto.",
    "hintChoose": "Scegli a cosa punta il segnaposto, a destra.",
    "pictureMissing": "L'immagine di questa mappa non è ancora su questo dispositivo.",
    "pinDetails": "Dettagli del segnaposto",
    "newPin": "Nuovo segnaposto",
    "entry": "Voce",
    "chooseAnEntry": "Scegli una voce",
    "noEntryLabelOnly": "Nessuna voce, solo un'etichetta",
    "labelOnTheMap": "Etichetta sulla mappa",
    "labelDefault": "Il nome della voce",
    "labelRequired": "Necessaria senza una voce",
    "placePin": "Posiziona il segnaposto",
    "label": "Etichetta",
    "openEntry": "Apri la voce",
    "openItsMap": "Apri la sua mappa",
    "position": "{{x}}% da sinistra, {{y}}% dall'alto",
    "removePin": "Rimuovi il segnaposto",
    "noPinsYet": "Ancora nessun segnaposto. Usa Aggiungi segnaposto, poi fai clic sulla mappa.",
    "shownOn": "Mostrato su",
    "openEntryOf": "Apri {{name}}",
    "removeMapTitle": "Rimuovere la mappa di {{name}}?",
    "removeMapMessage": "I segnaposto vengono rimossi con la mappa. L'immagine resta tra gli allegati della voce."
  },
  "worldPanel": {
    "checks": "Controlli",
    "findAndFixConsistencyIssuesIn": "I fatti, gli eventi e le relazioni del tuo mondo confrontati con il manoscritto. Nessuna IA.",
    "running": "In corso…",
    "runChecks": "Esegui i controlli",
    "lastRunAt": "Ultima esecuzione alle {{time}}",
    "oneAtATime": "Uno alla volta",
    "exclusiveRelation": "Relazione esclusiva",
    "noRelationIsExclusive": "Nessuna relazione è esclusiva",
    "exclusivityType": "Tipo di esclusività",
    "oneSourcePerTarget": "Una sola origine per ogni destinazione",
    "oneTargetPerSource": "Una sola destinazione per ogni origine",
    "oneAtATimeHint": "Una relazione che può valere per uno solo alla volta, come «possiede»: due proprietari della stessa cosa negli stessi momenti diventano un conflitto.",
    "rulesNeedRelations": "Le regole usano le tue relazioni. Aggiungine una in Collegamenti, come «possiede», poi rendila esclusiva qui.",
    "results": "Risultati",
    "whatTheChecksLookFor": "Cosa cercano i controlli",
    "twoHoldersAtOnce": "Due detentori contemporaneamente",
    "eventsOutOfOrder": "Eventi fuori ordine",
    "quotedPastItsLimit": "Citato oltre il suo limite",
    "linksToDeletedEntries": "Collegamenti a voci eliminate",
    "notesThatLostTheirPlace": "Note che hanno perso il loro posto",
    "relationsOverTime": "Relazioni nel tempo",
    "scopeOwnership": "Una cosa detenuta da due voci negli stessi momenti, a partire dai fatti confermati.",
    "scopeFlashback": "Un evento letto dopo uno che avviene più tardi nel mondo: un flashback, o una svista.",
    "scopeReveal": "Un fatto citato in una scena dopo l'ultima che avevi previsto per esso.",
    "scopeOrphans": "Note e fatti che rimandano a una voce o a una scheda della Biblioteca che non esiste più.",
    "scopeAnchors": "Un passaggio citato le cui parole si sono spostate o sono cambiate nella sua scena.",
    "scopeRelations": "Relazioni confrontate con la regola qui sopra e con le citazioni che riportano.",
    "filterResults": "Filtra i risultati",
    "all": "Tutti",
    "conflicts": "Conflitti",
    "warnings": "Avvisi",
    "needsData": "Servono dati",
    "noIssuesFound": "Nessun problema trovato",
    "theExecutedRulesFoundNoViolation": "Nulla viola i fatti e le regole che hai impostato. I Controlli conoscono solo ciò che hai registrato.",
    "notEnoughData": "Dati insufficienti",
    "quotesInTheText": "Citazioni nel testo",
    "anchorInPlace": "Al suo posto",
    "anchorMoved": "Spostata",
    "anchorGone": "Scomparsa",
    "reAnchor": "Riancora",
    "openScene": "Apri la scena",
    "checkedAt": "Controllato alle {{time}}.",
    "twoHold": "{{a}} e {{b}} detengono entrambi «{{object}}» nello stesso momento.",
    "heldTwice": "{{a}} detiene «{{object}}» due volte negli stessi momenti.",
    "flashbackSentence": "«{{earlier}}» avviene prima di «{{later}}» nel mondo ma viene letto dopo: un flashback, a meno che tu non lo volessi.",
    "revealSentence": "«{{fact}}» è citato in {{scene}}, dopo l'ultima scena che avevi previsto per esso.",
    "allowedUpToScene": "Previsto fino alla scena {{scene}}",
    "orphanFactSentence": "Un fatto («{{fact}}») riguarda una voce che è stata eliminata.",
    "orphanNoteSentence": "La nota su «{{excerpt}}» rimanda a una voce eliminata.",
    "orphanConceptSentence": "La nota su «{{excerpt}}» rimanda a una scheda della Biblioteca che non esiste più.",
    "movedSentence": "«{{excerpt}}» si è spostato in {{scene}}: riancora la nota perché lo segua.",
    "eventWithoutTime": "«{{title}}» non ha un tempo nel mondo, quindi il suo ordine non si può verificare.",
    "factWithoutTime": "«{{fact}}» non ha un intervallo di tempo, quindi il suo detentore non si può verificare.",
    "recordWithoutTime": "Un record non ha un tempo, quindi non si può verificare.",
    "aDeletedEntry": "una voce eliminata",
    "aDeletedEvent": "un evento eliminato",
    "aScene": "una scena",
    "fromTo": "Da {{start}} a {{end}}",
    "relativeToAnEvent": "Relativo a un evento",
    "timeNotSet": "Non impostato",
    "facts": "Fatti",
    "factsLead": "Ciò che affermi su ogni voce. I Controlli leggono quelli che confermi e li confrontano con il manoscritto.",
    "entries": "Voci",
    "addAnEntry": "Aggiungi una voce",
    "addTheFirstEntry": "Aggiungi la prima voce",
    "newEntityName": "Nome della nuova entità",
    "entityType": "Tipo di entità",
    "addEntity": "Aggiungi entità",
    "character": "Personaggio",
    "place": "Luogo",
    "object": "Oggetto",
    "faction": "Fazione",
    "other": "Altro",
    "deleteEntityReferencesBecomeOrphaned": "Elimina entità (i riferimenti restano orfani)",
    "deleteEntityName": "Elimina l'entità {{name}}",
    "noFactYet": "Ancora nessun fatto su {{name}}. Un nuovo fatto parte come proposto; confermalo perché conti.",
    "proposed": "Proposto",
    "confirmed": "Confermato",
    "rejected": "Rifiutato",
    "superseded": "Sostituito",
    "worldFact": "Fatto del mondo",
    "characterBelief": "Convinzione",
    "testimony": "Testimonianza",
    "authorHypothesis": "Ipotesi",
    "confirm": "Conferma",
    "confirmExplicitApproval": "Conferma (approvazione esplicita)",
    "newFactAbout": "Nuovo fatto su {{name}}",
    "predicatePlaceholder": "possiede",
    "predicate": "Predicato",
    "valuePlaceholder": "la spada",
    "value": "Valore",
    "kind": "Tipo",
    "epistemicKind": "Tipo epistemico",
    "kindHint": "Solo i fatti del mondo contano come verità; convinzioni, testimonianze e ipotesi sono conservate ma non verificate come canone.",
    "when": "Quando",
    "timeKind": "Tipo di tempo",
    "betweenTwoMoments": "Tra due momenti",
    "from": "Da",
    "to": "a",
    "startTick": "Istante di inizio",
    "endTick": "Istante di fine",
    "momentsHint": "Momenti sulla cronologia del mondo; la fine non è inclusa.",
    "reveal": "Rivelazione",
    "maximumRevealNarrativeIndex": "Rivelazione massima (indice narrativo)",
    "noLimit": "Nessun limite",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "Le citazioni di questo fatto in una scena successiva vengono segnalate.",
    "addFactProposed": "Aggiungi come proposto",
    "selectAnEntityToSeeAnd": "Scegli una voce per vedere e aggiungere i suoi fatti.",
    "noEntityYet": "Ancora nessuna voce. Aggiungi sopra un personaggio, un luogo o un oggetto, oppure nell'Enciclopedia.",
    "resultDetails": "Dettagli del risultato",
    "conflict": "Conflitto",
    "warning": "Avviso",
    "whatWasCompared": "Cosa è stato confrontato",
    "whatToDo": "Cosa fare",
    "comparedOwnership": "Fatti del mondo confermati con un intervallo di tempo. Due detentori della stessa cosa non possono sovrapporsi.",
    "comparedFlashback": "Il tempo di ogni evento nel mondo rispetto all'ordine della sua scena nel libro.",
    "comparedReveal": "L'ultima scena che hai previsto per un fatto rispetto alle scene che lo citano.",
    "comparedOrphans": "Ogni nota e fatto rispetto alle voci e alle schede della Biblioteca esistenti.",
    "comparedAnchors": "La citazione di ogni nota rispetto al testo attuale della scena.",
    "confirmOnlyOneOwnerInThe": "Mantieni un solo detentore per quei momenti: restringi uno degli intervalli di tempo, oppure riporta un fatto a proposto.",
    "ifTheSceneIsADeliberate": "Se la scena è un flashback voluto, tienila. Altrimenti sposta la scena o cambia il tempo dell'evento.",
    "raiseTheMaximumRevealSceneOf": "Consenti una scena successiva per il fatto, oppure sposta la citazione più indietro.",
    "restoreTheMissingEntityFromThe": "Ripristina la voce dalla cronologia dell'Enciclopedia, oppure elimina la nota o il fatto che rimanda a essa.",
    "useReAnchorManualOnThe": "Usa Riancora sulla citazione nei risultati, oppure apri la scena e seleziona di nuovo il passaggio.",
    "giveTheEventOrFactAn": "Dagli un tempo nel mondo, oppure lascialo senza: il controllo resta in silenzio invece di tirare a indovinare.",
    "selectAResult": "Seleziona un risultato",
    "detailsConstraintsAndSuggestedFixesAppear": "Qui compaiono ciò che è stato confrontato e cosa fare.",
    "thisAnnotationCannotBeReAnchored": "Questa nota non si può riancorare: «{{excerpt}}» manca o compare più di una volta nella scena.",
    "revisionTools": "Strumenti di revisione",
    "loadingRevisionTools": "Caricamento degli strumenti di revisione…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "Il contenuto è cambiato mentre veniva confermato. Scegli il contenuto e l'approvazione che avevi rivisto.",
    "theseChangesCannotBeCombinedInto": "Queste modifiche non si possono combinare in un Mondo valido. Scegli la versione completa da tenere; entrambe le copie restano nel recupero.",
    "thisDevice": "Questo dispositivo",
    "yourAccount": "Il tuo account",
    "viewWorld": "Vedi il Mondo",
    "previousSharedValue": "Valore condiviso precedente",
    "theActionCouldNotFinishYour": "L'azione non è terminata. Le tue modifiche locali sono conservate.",
    "worldSync": "Sincronizzazione del Mondo",
    "syncCodexPagesFactsTimelinesCollections": "Sincronizza pagine dell'Enciclopedia, fatti, cronologie, raccolte e allegati tra i dispositivi. Note e schizzi si sincronizzano da soli, qui sotto.",
    "syncWorldAutomatically": "Sincronizza il Mondo automaticamente",
    "n1PendingChange": "1 modifica in sospeso",
    "pendingPendingChanges": "{{pending}} modifiche in sospeso",
    "syncNow": "Sincronizza ora",
    "exportRecoveryCopies": "Esporta le copie di recupero",
    "compareBeforeSyncing": "Confronta prima di sincronizzare",
    "signInToTheLinkedAccount": "Accedi all'account collegato per sincronizzare. Le modifiche locali restano salvate.",
    "signInToCompareYourWorld": "Accedi per confrontare il tuo Mondo e attivare la sincronizzazione.",
    "chooseYourStartingWorld": "Scegli il tuo Mondo di partenza",
    "bothCopiesHaveTheSameContent": "Entrambe le copie hanno lo stesso contenuto.",
    "keepTheWorldOnThisDevice": "Tieni il Mondo su questo dispositivo, oppure usa la copia nel tuo account. Il Mondo locale e gli allegati precedenti vengono conservati nel recupero.",
    "keepThisDeviceSync": "Tieni questo dispositivo e sincronizza",
    "useAccountCopySync": "Usa la copia dell'account e sincronizza",
    "cancel": "Annulla",
    "reviewConcurrentChanges": "Rivedi le modifiche concorrenti",
    "chooseEachValueToKeepOther": "Scegli ogni valore da tenere. Le altre modifiche si uniscono automaticamente. Entrambe le versioni restano recuperabili.",
    "applyReviewedChoices": "Applica le scelte riviste",
    "syncingWorldAndAttachments": "Sincronizzazione di Mondo e allegati…",
    "codexPages": "Pagine dell'Enciclopedia",
    "onThisDevice": "Su questo dispositivo",
    "waitingToSync": "In attesa di sincronizzazione",
    "syncing": "Sincronizzazione…",
    "upToDate": "Aggiornato",
    "reviewNeeded": "Serve una revisione",
    "emptyText": "(testo vuoto)",
    "emptyList": "(elenco vuoto)",
    "worldStructure": "Struttura del Mondo",
    "labelFacts": "Fatti",
    "labelEvents": "Eventi",
    "labelKnowledge": "Conoscenza",
    "labelAnnotations": "Annotazioni",
    "labelRelationships": "Relazioni",
    "labelAttachments": "Allegati",
    "labelCollections": "Raccolte",
    "labelFolders": "Cartelle",
    "paused": "In pausa",
    "addedCount_one": "{{count}} aggiunto",
    "addedCount_many": "{{count}} aggiunti",
    "addedCount_other": "{{count}} aggiunti",
    "removedCount_one": "{{count}} rimosso",
    "removedCount_many": "{{count}} rimossi",
    "removedCount_other": "{{count}} rimossi",
    "changedCount_one": "{{count}} modificato",
    "changedCount_many": "{{count}} modificati",
    "changedCount_other": "{{count}} modificati",
    "removedValue": "Rimosso",
    "emptyValue": "Vuoto"
  },
  "worldReviewTools": {
    "deletedEntry": "Voce eliminata",
    "timeUnknown": "Tempo sconosciuto",
    "storyTimeInterval": "Intervallo nel tempo della storia",
    "relativeToEventPreserved": "Relativo a un evento (conservato)",
    "from": "Da",
    "until": "Fino a",
    "characterKnowledge": "Conoscenza del personaggio",
    "couldNotCheckTheSavedManuscriptRetry": "Non è stato possibile controllare il manoscritto salvato. Riprova.",
    "revisionTools": "Strumenti di revisione",
    "changeImpact": "Impatto di una modifica",
    "whatPointsToThisRecord": "Cosa rimanda a questo record?",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "Solo collegamenti espliciti, compresi quelli indiretti. Modificare un record non riscrive quelli che ne dipendono.",
    "impactRecord": "Record da analizzare",
    "chooseARecord": "Scegli un record",
    "linkedRecordsWorldRevision": "record collegati · revisione del Mondo",
    "directLink": "Collegamento diretto",
    "missingSourceScene": "Scena di origine mancante",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "Nessun record rimanda esplicitamente a questa voce. La prosa non collegata è fuori da questo controllo.",
    "whenDidTheyLearnIt": "Quando l'ha appreso?",
    "recordAcquisitionAndUseOnTheSameStoryTime": "Registra acquisizione e uso sullo stesso asse del tempo della storia. Supposizioni e convinzioni restano separate; l'ordine dei capitoli non è mai trattato come tempo della storia.",
    "recordKnowledge": "Registra la conoscenza",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "Non è stato possibile salvare. Controlla gli intervalli, oppure annulla e riapri se il Mondo è cambiato.",
    "character": "Personaggio",
    "knowledgeCharacter": "Personaggio della conoscenza",
    "chooseACharacter": "Scegli un personaggio",
    "fact": "Fatto",
    "knowledgeFact": "Fatto della conoscenza",
    "chooseAConfirmedWorldFact": "Scegli un fatto del mondo confermato",
    "acquired": "Acquisita",
    "acquisitionSource": "Origine dell'acquisizione",
    "noSourceAttached": "Nessuna fonte allegata",
    "use": "Uso",
    "scene": "Scena",
    "chooseAScene": "Scegli una scena",
    "knownInformation": "Informazione conosciuta",
    "belief": "Convinzione",
    "guess": "Supposizione",
    "passageSource": "Fonte del passaggio",
    "noPassageAttached": "Nessun passaggio allegato",
    "removeUse": "Rimuovi l'uso",
    "addUse": "Aggiungi l'uso",
    "confirmAndSave": "Conferma e salva",
    "cancel": "Annulla",
    "missingFact": "Fatto mancante",
    "atUnknownRelativeTime": "a tempo sconosciuto/relativo",
    "edit": "Modifica",
    "couldNotRemoveTheRecordRefreshAndRetry": "Non è stato possibile rimuovere il record. Aggiorna e riprova.",
    "checkSavedKnowledge": "Controlla la conoscenza salvata",
    "theWorldChangedSinceThisResultRunTheCheck": "Il Mondo è cambiato dopo questo risultato. Esegui di nuovo il controllo.",
    "recordedUseIsEarlierThanAcquisition": "L'uso registrato è precedente all'acquisizione",
    "recordedTimesAreInOrder": "I tempi registrati sono in ordine",
    "beliefOrGuessNotAKnowledgeConflict": "Convinzione o supposizione — non un conflitto di conoscenza",
    "notEnoughInformationToCompare": "Informazioni insufficienti per confrontare",
    "attachedPassagesMatchTheSavedText": "I passaggi allegati corrispondono al testo salvato",
    "aSourceIsMissingStaleOrBelongsToAnother": "Una fonte manca, è obsoleta o appartiene a un'altra scena",
    "authorRecordedTimesPassagesAreNotVerified": "Tempi registrati da chi scrive; i passaggi non sono verificati",
    "openScene": "Apri la scena",
    "noConfirmedKnowledgeUsesToCompare": "Nessun uso di conoscenza confermato da confrontare.",
    "openNamedScene": "Apri {{title}}",
    "recordSummary": "Usi: {{count}} · {{lifecycle}} · Acquisita {{time}}",
    "checkSummary": "Controllato alle {{time}} · {{count}} usi registrati. Aggiorna dopo aver modificato la prosa.",
    "resultsLimitedTo500Records": "Risultati limitati a 500 record",
    "linksAway": "{{depth}} collegamenti di distanza",
    "useNKind": "Usa {{n}} tipo",
    "useN": "Usa {{n}}",
    "useNSource": "Usa {{n}} fonte",
    "checking": "Controllo…"
  },
  "worldSection": {
    "overview": "Panoramica",
    "vault": "Archivio",
    "timeline": "Cronologia",
    "connections": "Collegamenti",
    "references": "Riferimenti",
    "checks": "Controlli",
    "analysis": "Analisi",
    "characters": "Personaggi",
    "locations": "Luoghi",
    "factions": "Fazioni",
    "objects": "Oggetti",
    "concepts": "Concetti",
    "worldViews": "Viste del mondo",
    "world": "Mondo",
    "browseByType": "Sfoglia per tipo",
    "filterByType": "Filtra per tipo",
    "all": "Tutti",
    "newEntry": "Nuova voce",
    "cercaNelCodex": "Cerca nell'Enciclopedia",
    "searchEntries": "Cerca voci…",
    "entry": "voce",
    "entries": "voci",
    "alsoAliases": "Anche: {{aliases}}",
    "noEntriesYetCreateTheFirst": "Ancora nessuna voce. Crea il primo personaggio, luogo o fazione.",
    "noEntryMatches": "Nessuna voce corrisponde.",
    "editName": "Modifica {{name}}",
    "edit": "Modifica",
    "archive": "Archivia",
    "confirmArchive": "Conferma l'archiviazione",
    "notesAndSketches": "Note e schizzi",
    "alsoKnownAs": "Noto anche come",
    "addADescriptionOneLineThat": "Aggiungi una descrizione — una riga che dica cos'è.",
    "none": "Nessuno",
    "yes": "Sì",
    "no": "No",
    "removedEntry": "Voce rimossa",
    "unavailableEntry": "Voce non disponibile",
    "noNotesYetEditTheEntry": "Ancora nessuna nota. Modifica la voce per descriverla.",
    "linkedScenes": "Scene collegate",
    "showTheEntriesOfABook": "Mostra le voci di un libro",
    "allBooks": "Tutti i libri",
    "bookLine": "Libro {{number}} · {{title}}",
    "inNoBookYet": "In nessun libro per ora",
    "scenesThatMentionThisEntryBy": "Le scene che citano questa voce per nome o alias compaiono qui.",
    "facts": "Fatti",
    "noFactRecordedFactsAreAdded": "Nessun fatto registrato. I fatti si aggiungono e si approvano nei Controlli.",
    "relations": "Relazioni",
    "noRelationYet": "Ancora nessuna relazione.",
    "proposed": " · proposta",
    "viewAll": "Vedi tutte",
    "attachments": "Allegati",
    "attachAnImageToUseIt": "Allega un'immagine per usarla come ritratto.",
    "kib": "KiB",
    "open": "Apri",
    "remove": "Rimuovi",
    "addAttachment": "Aggiungi allegato",
    "stateAtStoryTime": "Stato al tempo della storia",
    "tick": "Istante",
    "factsWithoutACompleteInterval": "fatti senza un intervallo completo.",
    "selectAnEntry": "Seleziona una voce",
    "charactersPlacesFactionsAndObjectsLive": "Qui vivono personaggi, luoghi, fazioni e oggetti, con i loro fatti, relazioni e allegati.",
    "recentChanges": "Modifiche recenti",
    "undoChange": "Annulla la modifica",
    "worldTimeline": "Cronologia del Mondo",
    "eventsPeopleAndPlacesInA": "Eventi, persone e luoghi in un contesto più ampio.",
    "noEventYet": "Ancora nessun evento",
    "addTheFirstEventWithA": "Aggiungi il primo evento con un tempo della storia, oppure lascia il tempo sconosciuto finché non lo sai.",
    "tick2": "istante",
    "plotEvent": "Evento di trama",
    "worldEvent": "Evento del mondo",
    "openScene": "Apri la scena",
    "unknownTime": "Tempo sconosciuto",
    "unknown": "sconosciuto",
    "seeHowYourWorldSPeople": "Guarda come sono collegati persone, luoghi e idee del tuo mondo.",
    "connectionsView": "Vista dei collegamenti",
    "graph": "Grafo",
    "list": "Elenco",
    "nothingToConnectYet": "Ancora nulla da collegare",
    "createEntriesInTheCodexAnd": "Crea voci nell'Enciclopedia e mettile in relazione nella vista Elenco.",
    "selectedEntry": "Voce selezionata",
    "relationSummary": "Riepilogo delle relazioni",
    "noSceneMentionsThisEntryYet": "Nessuna scena cita ancora questa voce.",
    "openInCodex": "Apri nell'Enciclopedia",
    "selectANodeToSeeIts": "Seleziona un nodo per vedere le sue relazioni e le sue scene.",
    "annotationsAnchoredInTheManuscriptAnd": "Annotazioni ancorate nel manoscritto e i file che tieni per il tuo mondo.",
    "addFile": "Aggiungi file",
    "annotations": "Annotazioni",
    "selectTextInTheManuscriptAnd": "Seleziona del testo nel manoscritto e usa «Annota» per ancorare un dispositivo, un'entità o una nota.",
    "scene": "Scena",
    "device": "Dispositivo",
    "entity": "Entità",
    "note": "Nota",
    "imagesPdfsNotesAndAudioYou": "Immagini, PDF, note e audio che alleghi al mondo o a una voce.",
    "linked": "Collegato",
    "orphan": "Orfano",
    "openFile": "Apri il file",
    "referenceDetails": "Dettagli del riferimento",
    "textAnnotation": "Annotazione di testo",
    "kind": "Tipo",
    "anchor": "Ancora",
    "concept": "Concetto",
    "created": "Creato",
    "anchorStatesValidStaleOrphanedAnd": "Gli stati delle ancore (valida, obsoleta, orfana) e il riancoraggio si calcolano nei Controlli.",
    "attachment": "Allegato",
    "type": "Tipo",
    "size": "Dimensione",
    "linkedTo": "Collegato a",
    "added": "Aggiunto",
    "confirmRemove": "Conferma la rimozione",
    "selectAnAnnotationOrAFile": "Seleziona un'annotazione o un file.",
    "exploreTheShapeOfYourStory": "Esplora la forma della tua storia: lunghezza, presenza e densità nelle scene.",
    "sceneLength": "Lunghezza delle scene",
    "wordsPerScene": "Parole per scena",
    "noScenesYet": "Ancora nessuna scena.",
    "titleFmtWords": "{{title}}: {{fmt}} parole",
    "entityDensity": "Densità di entità",
    "codexMentionsPerScene": "Menzioni dell'Enciclopedia per scena",
    "titleMentionsMentions": "{{title}}: {{mentions}} menzioni",
    "characterAppearanceMap": "Mappa delle apparizioni dei personaggi",
    "aDotWhereACharacterIs": "Un punto dove un personaggio è nominato in una scena",
    "addCharactersToTheCodexAnd": "Aggiungi personaggi all'Enciclopedia e nominali nelle scene.",
    "thisScene": "Questa scena",
    "words": "Parole",
    "paragraphs": "Paragrafi",
    "sentencesEst": "Frasi (stima)",
    "distinctWords": "Parole distinte",
    "annotatedDevices": "Dispositivi annotati",
    "n1000Words": "/ 1.000 parole",
    "repetitions": "Ripetizioni",
    "exportHtml": "Esporta HTML",
    "exportTxt": "Esporta TXT",
    "events": "Eventi",
    "confirmedFacts": "Fatti confermati",
    "recentlyChanged": "Modificati di recente",
    "changesToTheWorldWillBe": "Le modifiche al mondo saranno elencate qui, ciascuna con un annulla.",
    "undo": "Annulla",
    "startHere": "Parti da qui",
    "overviewEmptyLead": "Le persone, i luoghi e gli eventi della tua storia, collegati alle scene in cui compaiono.",
    "addACharacter": "Aggiungi un personaggio",
    "addACharacterText": "Chi è, cosa vuole e cosa ostacola il suo cammino.",
    "addAPlace": "Aggiungi un luogo",
    "addAPlaceText": "Dove si svolgono le scene: una città, una nave, una sola stanza.",
    "addAnEventText": "Qualcosa che accade nella storia, con la sua data o senza.",
    "inThisWorld": "In questo mondo",
    "createAnEntry": "Crea una voce",
    "aCharacterAPlaceAFaction": "Un personaggio, un luogo, una fazione, un oggetto o un concetto.",
    "addAnEvent": "Aggiungi un evento",
    "withAnExactStoryTimeOr": "Con un tempo esatto della storia o sconosciuto.",
    "runTheChecks": "Esegui i controlli",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "Proprietari, ordine, rivelazioni e relazioni nel tempo, confrontati con il testo.",
    "loadingTheWorld": "Caricamento del mondo…",
    "maps": "Mappe",
    "openItsMap": "Apri la sua mappa",
    "addAMap": "Aggiungi una mappa",
    "pinnedOn": "Fissato su",
    "typeCharacter": "Personaggio",
    "typeLocation": "Luogo",
    "typeObject": "Oggetto",
    "typeFaction": "Fazione",
    "typeConcept": "Concetto",
    "annotationsToReAnchor_one": "{{count}} annotazione da riancorare.",
    "annotationsToReAnchor_many": "{{count}} di annotazioni da riancorare.",
    "annotationsToReAnchor_other": "{{count}} annotazioni da riancorare."
  }
}
